import React, { useEffect, useRef, useState } from "react";
import Loader from "../../../components/loader/loader";
import Underline from "../../../components/page/home/underline/underline";
import About from "./components/about";
import Accomplishments from "./components/accomplishments";
import Banner from "./components/banner";
import HomeEvents from "./components/events";
import Gallery from "./components/gallery";
import News from "./components/news";
import OrgStructureComp from "./components/orgstructure";
import Personalities from "./components/quotes";
import ScopeAct from "./components/scopeofact";
import jwtDecode from "jwt-decode";
import Swal from "sweetalert2";

import "./home.css";
import Partners from "./components/partner copy";
import NewsUpdates from "./components/NewsUpdates";
import { public_event_list } from "../public.api";
import moment from "moment";

export default function Home(props) {
  const top = useRef(null);
  const news = useRef(null);
  const gallery = useRef(null);
  const event = useRef(null);
  const [eventData, setEventData] = useState(false);
  let prevPath = sessionStorage.getItem("continueFrom");
  const scrollToPrevPath = (path) => {
    if (path === "events") event?.current?.scrollIntoView();
    else if (path === "news") news?.current?.scrollIntoView();
    else if (path === "gallery") gallery?.current?.scrollIntoView();
    else top.current.scrollIntoView();

    sessionStorage.removeItem("continueFrom");
  };
  const statusViewed = sessionStorage.getItem("viewed");

  useEffect(() => {
    scrollToPrevPath(prevPath);
  }, []);
  const fetchEvent = () => {
    public_event_list().then((res) => {
      const fData = res?.data?.filter((item) =>
        moment(item?.[props.state.language]?.eventDate, "DD-MM-YYYY").isAfter(moment())
      );
      setEventData(fData);
    });
  };

  useEffect(() => {
    fetchEvent();
  }, []);
  useEffect(() => {
    if (!statusViewed) {
      Swal.fire({
        title: "Website updates are in progress.",
        text: " You can continue browsing the site, but if you experience any issues, please contact us.",
        // icon: "info",
        confirmButtonText: "OK",
        allowOutsideClick: false,
        width: "600px",
      }).then(() => {
        sessionStorage.setItem("viewed", "yes");
      });
    }
  }, [statusViewed]);

  useEffect(() => {
    fetchEvent();
  }, []);
  return (
    <div className="bgc-white" ref={top}>
      {/* ======================= Banner  =================================================================== */}
      <Banner {...props} />
      {/* =================================================================================================== */}
      {/* ======================= News  ===================================================================== */}
      <div className="news bgc-default" ref={news}>
        <News {...props} />
      </div>
      <div style={{ paddingTop: "20px", paddingBottom: "20px" }}>
        <NewsUpdates {...props} />
      </div>
      {/* =================================================================================================== */}
      {/* ======================= Scope  ==================================================================== */}
      <ScopeAct {...props} />
      {/* =================================================================================================== */}
      {/* ======================= About  ==================================================================== */}
      <div className=" bgc-white">
        <About {...props} />
      </div>

      {/* =================================================================================================== */}
      {/* ======================= Organization Strecture  =================================================== */}
      <div className="bgc-white homePeronalities">
        <OrgStructureComp {...props} />
      </div>
      {/* <div className="pad-20 bgc-white"></div> */}
      <div className="events ">
        <Personalities {...props} />
      </div>
      {/* =================================================================================================== */}
      {/* ======================= Events  =================================================================== */}
      {eventData.length > 0 && (
        <div className="new-events" ref={event}>
          <div className="event-main-title">
            {props.state.language === "ma" ? "ഇവന്റുകൾ" : "Events"}
          </div>

          <HomeEvents {...props} />
        </div>
      )}
      {/* =================================================================================================== */}
      {/* ======================= Gallery  ================================================================== */}
      <div className="bgc-white gal-con-new " ref={gallery} >
        <div className="galleryTitle">
          {props.state.language === "ma" ? "ഗാലറി" : "Our Gallery"}
        </div>

        <Gallery {...props} />
      </div>
      {/* =================================================================================================== */}
      {/* ======================= Quotes  =================================================================== */}
      {/*  */}

      {/* =================================================================================================== */}
      {/* ======================= Accomplishment  =========================================================== */}

      <div className="bgc-white">
        <Accomplishments {...props} />
      </div>
      <div className="bgc-white">
        <Partners {...props} />
      </div>

      {/* =================================================================================================== */}
    </div>
  );
}
